import { USER_UPGRADE_CLEAR } from '@/constants/constants';
import { callGetegService } from '@/utils/commonUtils';
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  // CLIENT DATA
  USER_INIT: 'USER/USER_INIT',
  USER_INIT_SUCCESS: 'USER/USER_INIT_SUCCESS',
  USER_UPGRADE: 'USER/USER_UPGRADE',
  USER_UPGRADE_SUCCESS: 'USER/USER_UPGRADE_SUCCESS',
  USER_UPGRADE_FAIL: 'USER/USER_UPGRADE_FAIL',
  USER_LOGOUT: 'USER/USER_LOGOUT',
  /* GETEG SERVICE */
  GETEG_SERVICE_BEGINS: 'USER/GETEG_SERVICE_BEGINS',
  SET_NEW_AP: 'USER/SET_NEW_AP',
  SET_NEW_AP: 'USER/SET_NEW_AP',

};

export const actions = {
  // Client data actions
  userInit: () => ({ type: types.USER_INIT }),
  successUserInit: (data) => ({
    type: types.USER_INIT_SUCCESS,
    payload: { data },
  }),
  upgradeUser: (params) => ({ type: types.USER_UPGRADE, userInfo: params }),
  successUpgradeUser: () => ({ type: types.USER_UPGRADE_SUCCESS }),
  failUpgradeUser: () => ({ type: types.USER_UPGRADE_FAIL }),
  logoutUser: (user) => ({ type: types.USER_LOGOUT, user }),
  upgradeClear: () => ({ type: USER_UPGRADE_CLEAR }),
  /* GETEG SERVICE */
  getegService: (xcol) => ({ type: types.GETEG_SERVICE_BEGINS, payload: xcol }),
  setNewAp: (newAp) => ({ type: types.SET_NEW_AP, payload: newAp}),
};
export const initialState = {
  // CLIENT DATA
  userLogged: false,
  userUpgradeFetching: false,
  userUpgradeError: false,
  foa: false,
  pikolin: false,
  getegServiceDone: false,
  novum: false,
  newAp: null,
  userInfo: null,
  selfEmployed: false,
};
function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { user } = payload;
      return {
        ...state,
        ...user,
      };
    }
    case USER_UPGRADE_CLEAR:
      return initialState;
    case types.USER_INIT:
      return { ...state };
    case types.USER_INIT_SUCCESS:
      return {
        ...state,
        userLogged: true,
        telcoOut: payload.data.telcoOut.telcoOut,
        foa: payload.data.foa,
        scope: payload.data.scope,
        pikolin: payload.data.pikolin,
        novum: payload.data.novum,
        userInfo: payload.data.userInfo,
        selfEmployed: payload.data.selfEmployed,
      };
    case types.USER_UPGRADE:
      return { ...state, userUpgradeFetching: true };
    case types.USER_UPGRADE_SUCCESS:
      return { ...state, userUpgradeFetching: false, userUpgradeError: false };
    case types.USER_UPGRADE_FAIL:
      return { ...state, userUpgradeFetching: false, userUpgradeError: true };
    /* GETEG SERVICE */
    case types.GETEG_SERVICE_BEGINS: {
      // callGetegService(payload);
      return {
        ...state,
        getegServiceDone: true,
      };
    }
    case types.SET_NEW_AP: {
      return { 
        ...state,
        newAp: payload,
      };
    }
    default:
      return state;
  }
}

export default reducer;
